import { createElement } from "react";
import { ClientThemeConfig } from "../../types";
import lightlogo from "../../../assets/broadham-light-transparent.png";
import darklogo from "../../../assets/broadham-dark-transparent.png";
import { PerformanceZoneIcon }  from "./icons/PerformanceZoneIcon";
import { OperationalZoneIcon }  from "./icons/OperationalZoneIcon";
import { CollaborationZoneIcon } from "./icons/CollaborationZoneIcon";
import { ReportingZoneIcon }    from "./icons/ReportingZoneIcon";
import { RiskZoneIcon }         from "./icons/RiskZoneIcon";

// Colours derived from Figma screens
const NAVY = "#1B2D5B";       // sidebar background
const GREEN = "#27AE60";      // primary CTAs / action buttons
const GREEN_DARK = "#1E8449"; // hover / dark variant
const TEAL = "#00897B";       // secondary accent

export const demoTheme: ClientThemeConfig = {
  lightPalette: {
    mode: "light",
    primary: { main: GREEN, dark: GREEN_DARK, contrastText: "#FFFFFF" },
    secondary: { main: TEAL },
    background: {
      default: "#F5F6FA",
      paper: "#FFFFFF",
    },
  },
  darkPalette: {
    mode: "dark",
    primary: { main: "#11f683", dark: GREEN, contrastText: "#FFFFFF" },
    secondary: { main: "#4DB6AC" },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    button: { fontWeight: 600, textTransform: "uppercase" },
  },
  branding: {
    appName: "Capital Delivery",
    platformName: "Water & Portfolio Platform",
    logoLight: lightlogo,
    logoDark: darklogo,
    faviconUrl: `${import.meta.env.BASE_URL}broadham-green-favicon.svg`,
    logoMaxWidth: "112px",
    logoMaxHeight: "50px",
  
  },
  layout: {
    sidebarBackground: NAVY,
    sidebarTextPrimary: "#FFFFFF",
    sidebarTextSecondary: "rgba(255, 255, 255, 0.80)",
    sidebarActiveItemBg: "#2D52D6",          // solid bright-blue active pill
    sidebarLogoBoxBg: "#FFFFFF",             // white box
    sidebarLogoBoxText: NAVY,                // navy "CD" initials
    appBackground: "#EAECF4",
    // Dashboard zone icon colours — matching Figma
    zoneIconColors: {
      "Performance Optimisation Zone": "#7C3AED",   // violet/purple
      "Commercial Controller":         "#0891B2",   // cyan
      "Operational Delivery Zone":     "#0891B2",   // cyan
      "Collaboration Zone":            "#9333EA",   // purple
      "Risk & Compliance Controller":  "#0284C7",   // blue
      "Vision Studio":                 "#D97706",   // amber
      "Reporting Zone":                "#16A34A",   // green
    },
    dashboardItemVariant: "plain",
    // Custom zone icons matching Figma designs
    zoneIcons: {
      "Performance Optimisation Zone": createElement(PerformanceZoneIcon),
      "Operational Delivery Zone":     createElement(OperationalZoneIcon),
      "Collaboration Zone":            createElement(CollaborationZoneIcon),
      "Reporting Zone":                createElement(ReportingZoneIcon),
      "Risk & Compliance Controller":  createElement(RiskZoneIcon),
    },
    portfolioCardVariant: "classic",
    projectCardVariant: "classic",
    stageChipColors: {
      "Work Request":                   { bg: "#EDE9FE", text: "#7C3AED" },
      "Estimate / Validation":          { bg: "#CFFAFE", text: "#0891B2" },
      "Feasibility / Conceptual Design":{ bg: "#D1FAE5", text: "#065F46" },
      "Detailed Design":                { bg: "#FEF3C7", text: "#92400E" },
      "Pre-Construction":               { bg: "#DBEAFE", text: "#1D4ED8" },
      "Construction":                   { bg: "#DCFCE7", text: "#166534" },
      "Commissioning":                  { bg: "#FFEDD5", text: "#C2410C" },
      "Project Closure":                { bg: "#F3F4F6", text: "#374151" },
    },
    hiddenProjectFormFields: ["g17", "hc_code"],
    hideProjectCommercialDashboard: true,
    hideProjectAssetDetails: true,
    showProjectActivityList: true,
    hidePortfolioSummary: true,
    showPortfolioActivityList: true,
  },
};

